module.exports = {"150424100":"林西镇","150424101":"新城子镇","150424102":"新林镇","150424103":"五十家子镇","150424104":"官地镇","150424105":"大井镇","150424106":"统部镇","150424200":"大营子乡","150424201":"十二吐乡","150424400":"城北街道","150424401":"城南街道","150424402":"内蒙古林西工业园区"}


//////////////////
// WEBPACK FOOTER
// ./src/town/150424.json
// module id = 509
// module chunks = 0